import AcceptedResult from './AcceptedResult';
export default AcceptedResult;
